import DB_PATH from "../DB_PATH";
import firebase from "../firebase";
export const getFirebaseKey = () => {
  const planRef = firebase.database().ref(`${DB_PATH.PLAN}/`);
  return planRef.push().key;
};
